import Component from '../Component';

/**
 * The `Separator` component defines a menu separator item.
 */
class Separator extends Component {
  view() {
    return m("li", {
      className: "Dropdown-separator"
    });
  }
}
Separator.isListItem = true;
export default Separator;
flarum.reg.add('core', 'common/components/Separator', Separator);